import { module } from 'angular';

import { AdministratorFilter, default as administratorFilterName } from './filter/administrator/administrator-filter.component.ajs';
import { AgentFilter, default as agentFilterName } from './filter/agent/agent-filter.component.ajs';
import { default as supervisorFilterName, SupervisorFilter } from './filter/supervisor/supervisor-filter.component.ajs';
// import { Filter, View } from './';
import { default as userTrackingTableName, UserTrackingTable } from './table/tracking-table.component.ajs';
import { default as userTrackingServiceName, UserTrackingService } from './tracking.service';
import { AdministratorView, default as adminViewName } from './view/administrator/administrator-view.component.ajs';
import { AgentView, default as agentViewName } from './view/agent/agent-view.component.ajs';
import { default as supViewName, SupervisorView } from './view/supervisor/supervisor-view.component.ajs';

export default module('contact.tracking', [])
  .component(userTrackingTableName, new UserTrackingTable())
  .component(administratorFilterName, new AdministratorFilter())
  .component(agentFilterName, new AgentFilter())
  .component(supervisorFilterName, new SupervisorFilter())
  .component(adminViewName, new AdministratorView())
  .component(agentViewName, new AgentView())
  .component(supViewName, new SupervisorView())
  .service(userTrackingServiceName, UserTrackingService).name;
